import { SiteLogoActionType } from './actions/site-logo-action-type.enum';
import { SiteLogoActions } from './actions/site-logo-action.type';
import { SiteLogoState, SiteLogoStateInterface } from './models/site-logo-state.model';

const initialState: SiteLogoState = new SiteLogoState({
  logoFileHref: undefined,
});

export function siteLogoReducer(state: SiteLogoStateInterface = initialState,
                                action: SiteLogoActions): SiteLogoStateInterface {
  switch (action.type) {

    //// Site Logo ////

    case SiteLogoActionType.LoadSiteLogoCompleted:
      const logoHref: string = action.payload;

      return {
        ...state,
        logoFileHref: logoHref,
      };

    case SiteLogoActionType.DeleteSiteLogoCompleted:
      return {
        ...state,
        logoFileHref: ' ',
      };
  }
}
